import type { EscopoMacroCasca } from "./types-escopo-macro-secao";

/** O que cada estado de escopo mostra (Figma 10691:1406): linhas recolhidas e/ou o escopo novo aberto. */
export function useEscopoMacroSecao({ estado, escopos, total }: EscopoMacroCasca) {
  const comLinhas = estado !== "primeiro-escopo";

  return {
    estado,
    total,
    linhas: comLinhas
      ? escopos.map((escopo) => ({ ...escopo, testId: `escopo-macro-linha-${escopo.id}` }))
      : [],
    comNovo: estado !== "com-escopos",
  };
}
